exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.project-profile-map-legend{background-color:#C3BC9F\n}\n.project-create-edit input::placeholder{color:#0B7FC7;opacity:.54\n}\n", ""]);

// exports
